






























import { Component, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CloseIcon from '@/components/icons/Close.vue';
import segmentIo from '@/utils/segment.io';
import gsap from 'gsap';
import ManagerService from '@/api/ManagerService';

@Component({
  components: {
    Typography,
    CloseIcon
  }
})
export default class DoneBar extends Vue {
  managerService = new ManagerService();

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  async onClose() {
    segmentIo.track('Clicked Close Onboarding Call Banner');
    gsap.to(this.$refs.onboardingCallBanner, {
      height: 0,
      opacity: 0,
      duration: 0.4,
      onComplete: () => {
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.businessInfo,
          onboardingMeeting: {
            ...this.businessInfo.onboardingMeeting,
            isConfirmedBannerViewed: true
          }
        });
      }
    });

    await this.managerService.dismissOnboardingCallBanner();
  }
}
